var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Page", { staticClass: "remark", attrs: { title: _vm.title } }, [
    _c("div", [
      _c("div", { staticClass: "content" }, [
        _c("div", { staticClass: "name" }, [_vm._v("活动名称")]),
        _vm._v(" "),
        _c("div", { staticClass: "table" }, [
          _vm._v(_vm._s(_vm.campMember.campName))
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "swaper" },
          [
            _c(
              "van-swipe",
              {
                staticStyle: { width: "100%", height: "100%" },
                attrs: { autoplay: 3000 }
              },
              _vm._l(_vm.images, function(image, index) {
                return _c(
                  "van-swipe-item",
                  {
                    key: index,
                    on: {
                      click: function($event) {
                        return _vm.ImagePreview(index)
                      }
                    }
                  },
                  [
                    _c("img", {
                      staticStyle: { width: "100%", height: "100%" },
                      attrs: { src: image }
                    })
                  ]
                )
              }),
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "appraise" }, [
        _c("span", { staticClass: "appraise_ico" }),
        _vm._v(" 点评\n    ")
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "stars_content" },
        [
          _c(
            "van-row",
            [
              _c(
                "van-col",
                { staticClass: "appraise_person", attrs: { span: "12" } },
                [_vm._v(_vm._s(_vm.campMember.reviewUserName || "点评人"))]
              ),
              _vm._v(" "),
              _c(
                "van-col",
                { attrs: { span: "12" } },
                [
                  _c("van-rate", {
                    staticClass: "stars",
                    staticStyle: { "text-align": "center" },
                    attrs: {
                      value: _vm.campMember.U_ReviewScore,
                      count: _vm.count,
                      readonly: false,
                      color: "#E10913"
                    },
                    on: { change: _vm.changeRate }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("van-field", {
            staticClass: "textarea",
            attrs: {
              type: "textarea",
              placeholder: "请输入备注内容描述",
              rows: "3",
              autosize: ""
            },
            model: {
              value: _vm.campMember.U_Review,
              callback: function($$v) {
                _vm.$set(_vm.campMember, "U_Review", $$v)
              },
              expression: "campMember.U_Review"
            }
          }),
          _vm._v(" "),
          _c(
            "van-row",
            [
              _c(
                "van-col",
                { staticClass: "appraise_time", attrs: { span: "24" } },
                [
                  _c("van-icon", {
                    staticClass: "icon",
                    attrs: { name: "underway-o" }
                  }),
                  _vm._v(_vm._s(_vm.campMember.reviewTime) + "\n        ")
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.$wxuserUtil.hasFunAuth(
        _vm.menuId,
        _vm.$wxuserUtil.funcKey.ReviewCreated,
        true,
        "无点评权限"
      )
        ? _c("div", { staticClass: "bottom-btn flex" }, [
            _c(
              "div",
              { staticClass: "item1 btn save", on: { click: _vm.back } },
              [_vm._v("返回")]
            ),
            _vm._v(" "),
            !_vm.campMember.reviewUser
              ? _c(
                  "div",
                  { staticClass: "item1 btn sub", on: { click: _vm.sub } },
                  [_vm._v("提交")]
                )
              : _vm._e()
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6aa485a2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6aa485a2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/active/activeRemark.vue
// module id = null
// module chunks = 